export default __webpack_public_path__ + "static/media/18.0d63cb8e.jpg";